module.exports = __webpack_public_path__ + "img/social-share-light.b39aaad5.png";